import {DataBaseComponent, DataBaseComponentState} from "../../components/DataBaseComponent";
import SaveDialogLayout from "../../components/DialogLayout/SaveDialogLayout";
import repository from "../../client/repository";
import * as React from "react";
import ReefMultiSelect from "shared/ReefMultiSelect";
import {ReefResource} from "client/resources/reefResource";
import { Callout } from "@octopusdeploy/design-system-components";
import InternalRedirect from "components/Navigation/InternalRedirect";
import routeLinks from "routeLinks";

interface Props {
    reefs: ReefResource[];
}

interface State extends DataBaseComponentState {
    excludedReefIds: string[];
    redirectTo?: string;
}

class PurgePooledInstancesDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            excludedReefIds: []
        };
    }

    render() {
        if (this.state.redirectTo) {
            return <InternalRedirect to={this.state.redirectTo}/>;
        }

        return <SaveDialogLayout
            title="Purge pooled instances" saveButtonLabel="Purge and refresh"
            onSaveClick={() => this.purgePooledInstances()}
            errors={this.state.errors}
            busy={this.state.busy}>
            <Callout type="warning" title="All pooled instances will be deleted">
                A separate task runs for each selected reef. Each reef provisions a fresh set of pooled
                instances and, once they are ready, deletes the existing pooled instances.
                Pooled instances that begin customization before being processed are not purged.
            </Callout>
            <ReefMultiSelect
                label="Reefs to exclude"
                items={this.props.reefs}
                value={this.state.excludedReefIds}
                onChange={excludedReefIds => this.setState({excludedReefIds})}
            />
        </SaveDialogLayout>;
    }

    private async purgePooledInstances(): Promise<boolean> {
        return await this.doBusyTask(async () => {
            await repository.Reefs.purgePooledInstances({
                ExcludedReefIds: this.state.excludedReefIds
            });
            this.setState({ redirectTo: routeLinks.backgroundTasks.root });
        });
    }
}

export default PurgePooledInstancesDialog;
